import type { EndPointConfig } from '../types/config';

// Build configuration from environment variables
// This will be populated at build time from .env
export const endPointConfig: EndPointConfig = {
  itemServiceOrigin: import.meta.env.TWINIT_ITEM_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  passportServiceOrigin: import.meta.env.TWINIT_PASSPORT_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  fileServiceOrigin: import.meta.env.TWINIT_FILE_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  datasourceServiceOrigin: import.meta.env.TWINIT_DATASOURCE_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  graphicsServiceOrigin: import.meta.env.TWINIT_GRAPHICS_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  notificationServiceOrigin: import.meta.env.TWINIT_NOTIFICATION_SERVICE_ORIGIN || 'https://sandbox-api.invicara.com',
  baseRoot: import.meta.env.TWINIT_BASE_ROOT || window.location.origin ||'http://localhost:8083',
  organizationId: import.meta.env.TWINIT_ORGANIZATION_ID || undefined,
  applicationId: import.meta.env.TWINIT_APPLICATION_ID || undefined,
  projectId: import.meta.env.TWINIT_PROJECT_ID || undefined,
  userGroupId: import.meta.env.TWINIT_USER_GROUP_ID || undefined,
};

// Check if window.endPointConfig exists (injected via script tag)
// This allows runtime configuration override
declare global {
  interface Window {
    endPointConfig?: Partial<EndPointConfig>;
  }
}

export function getConfig(): EndPointConfig {
  // Merge with any runtime config from window
  if (typeof window !== 'undefined' && window.endPointConfig) {
    return {
      ...endPointConfig,
      ...window.endPointConfig,
    };
  }
  return endPointConfig;
}

export default getConfig;


